// Copyright (c) 2016 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import Registrations, {getDefaultState as getRegistrationsDefaultState} from './registrations';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    hasSearchResults: t.Boolean,
    registrations: Registrations,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        registrations: getRegistrationsDefaultState(),
        reportsAccordion: getAccordionDefaultState('registration-review-reports'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: ''
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/registration-review/state/index.js